import styled, { css } from 'styled-components';

import { layout } from '@prisjakt/ui-base';
import ListItem from '@prisjakt/ui-list-item';
import { Image } from '@prisjakt/ui-list-item/src/styles';

const sidebarMenuItemStyles = css`
  font-weight: 900;
`;

const originalMenuItemStyles = () => css`
  background-color: ${props => props.theme.bg.primary};
  border-bottom: 1px solid ${props => props.theme.lines.primary};
  height: 55px;
  padding: 20px 10px 20px 45px;
`;

export const LogoutButtonWrapper = styled.div`
  margin-left: ${layout.spacing.xSmall};
  margin-right: ${layout.spacing.xSmall};
`;

export const MenuItems = styled.div`
  margin-bottom: ${layout.spacing.xSmall};
`;

type MenuItemProps = {
  sidebar: boolean;
};

const menuItemStyles = () =>
  css<MenuItemProps>`
    ${props =>
      props.sidebar ? sidebarMenuItemStyles : originalMenuItemStyles};
  `;

export const MenuItem = styled(ListItem)`
  ${menuItemStyles}

  ${Image} {
    margin-right: ${layout.spacing.small};
  }
`;
